var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ProfessionPageHeading"},[_c('BlockHeading',{attrs:{"title":_vm.$t('professionalsPage.title', {
        thePerson: _vm.profession.theperson,
      }),"subtitle":_vm.$t('professionalsPage.subtitle', {
        thePerson: _vm.profession.theperson.toLowerCase(),
      }),"paragraph":_vm.$t('professionalsPage.titleParagraph', {
        professionObjective: _vm.profession.objective,
      })}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }